var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"enterprise-style-box"},[_c('ywhz-title-style-card',{attrs:{"title":_vm.$t('menu.menu5-3'),"subtitle":"PROFESSIONAL TEAM"}}),_c('div',{staticClass:"layout-width layput-ej",attrs:{"id":"articled"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }